export default "__VITE_ASSET__CMHxcMSr__"